import { SVGProps } from "react";

export default function DoorOpen({ color, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
      width="64"
      height="64"
      viewBox="0 0 32 32"
      style={{ display: "block", color: color ?? "rgb(74, 85, 101)" }}
      {...props}
    >
      <path
        fill="currentColor"
        d="m15.875 4l-.094.031l-8 1.875L7 6.094v20.25l.813.125l8 1.5l.093.031H18V4zM20 6v2h3v16h-3v2h5V6zm-4 .031V26l-7-1.313V7.657zM14.344 15c-.367 0-.688.45-.688 1s.32 1 .688 1s.656-.45.656-1s-.29-1-.656-1"
      ></path>
    </svg>
  );
}
